import * as React from 'react';
import { useCitation_unstable } from './useCitation';
import { renderCitation_unstable } from './renderCitation';
import { useCitationStyles_unstable } from './useCitationStyles.styles';
import type { CitationProps } from './Citation.types';
import type { ForwardRefComponent } from '@fluentui/react-components';
import { useCustomStyleHook } from '@fluentui-copilot/react-provider';

// Citation component - TODO: add more docs
export const Citation: ForwardRefComponent<CitationProps> = React.forwardRef((props, ref) => {
  const state = useCitation_unstable(props, ref);

  useCitationStyles_unstable(state);
  useCustomStyleHook('useCitationStyles')(state);

  return renderCitation_unstable(state);
});

Citation.displayName = 'Citation';
